
import { collection, query, getDocs, where, addDoc, doc, deleteDoc, updateDoc, arrayUnion, arrayRemove, getDoc } from "firebase/firestore";
import { db, storage } from "./firebase";
import { ref, getDownloadURL, deleteObject, uploadBytes } from "firebase/storage";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification, reauthenticateWithCredential, verifyBeforeUpdateEmail} from "firebase/auth";
import { EmailAuthProvider } from "firebase/auth/web-extension";
import { auth } from "./firebase";


// ==============================================================================================
// |------------------------------------------- Main -------------------------------------------|
// ==============================================================================================

// ================================
// Functions to get an existed data
// ================================

// Currently not in use => attempt to fetch all the images from
// The storage according to website document
// Basically created to prevent refetch at any render, and lower the requests traffic
// Right now without any success => then neglected for now
export async function loadAllImagesData(_website){
    if(!_website) return;
    try{
        const allImages = [
            _website.settings.logo,
            ..._website.settings.advertisments.map(a => a),
            ..._website.settings.categories.map(c => c.imgURL),
            ..._website.settings.categories.flatMap(c => c.products.map(p => p.imgURL)),
        ];
        const filteredImages = allImages.filter(img => img!==null)
        // console.log(filteredImages);
        const URLs = await Promise.all(filteredImages.map(async url => {
            const res = await getStorageImage(url, _website);
            return {url, res};
        }))
        const map = {};
        const data = new Promise.resolve(URLs.filter(Boolean).forEach(({ url, res }) => {
            map[url] = res;
        }));
        
        return data;
    } catch(err){
        console.error("Error on loading all images at firebase: ",err);
        return null;
    }
}

// Get the image from storage by giving the related path
// If failed returning the default webingo logo
export async function getStorageImage(path, _website){
    const imgRef = ref(storage, path || "webingo_resources_def/logo/Webingo_logo.png");
    const URL = await getDownloadURL(imgRef);
    return URL;
}

// Get the collection docs dynamically by the collection name
export async function getCollectionDocs(collectionName){
    if(!collectionName || collectionName.length === 0) return;
    try{
        const collectionRef = collection(db, collectionName);
        const querySnapshot = await getDocs(collectionRef);

        const fetchedDocs = [];
        querySnapshot.forEach(doc =>{
            // console.log(doc.data());
            return fetchedDocs.push({
                ...doc.data(),
                id:doc.id
            })}
        )
        
        return fetchedDocs;
    } catch(err){
        console.error("Error fetching collection docs at firebase: ", err);
        return [];
    }
}
// Get a website document acording to a specific parameter requested
export const getWebsite = async(param, reqParam)=>{
    if(!reqParam || !param || reqParam === undefined || param === undefined || reqParam === null || param === null){
        alert("something went wrong at get website");
        return null;
    }
    try {
        const websitesRef = collection(db, "websites");
        const q = query(
            websitesRef,
            where(param, "==", reqParam)
        );
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            console.log("No matching website found for the provided credentials.");
            return null;
        }
        const websiteDoc = querySnapshot.docs[0];
        return { id: websiteDoc.id, ...websiteDoc.data() };
    } catch (error) {
        console.error("Error fetching website by owner credentials:", error);
        return null;
    }
}
// Get any data on the collection document by its path and id
export const getData = async(_websiteID, _path, _objectID)=>{
    try {
        const ref = doc(db, "websites", _websiteID);
        const snap = await getDoc(ref);

        if (!snap.exists()) return null;

        const data = snap.data();

        // Split the path "settings.clients" to segments => ["settings", "clients"]
        const segments = _path.split(".");

        // Navigate step-by-step inside the doc data to get to related path object
        let current = data;
        for (const segment of segments) {
            if (current && typeof current === "object" && segment in current) {
                current = current[segment];
            } else {
                return null; // path invalid
            }
        }

        // The result is an array => find object by it's _id
        if (Array.isArray(current)) {
            return current.find(item => item._id === _objectID) || null;
        }

        // The result is an object => check if its _id matches
        if (typeof current === "object" && current._id === _objectID) {
            return current;
        }

        // Nothing matches => return null
        return null;
    } catch (error) {
        console.error("Error getting data at firebase: ",error);
        return null;
    }
}
// Get fresh data of current user connected from website document
export const getCurrentUser = async(website, clientID)=>{
    try {
        const websiteRef = doc(db, "websites", website.id);
        const websiteSnap = await getDoc(websiteRef);
        const freshWebsite = websiteSnap.data();
        const user = freshWebsite?.settings?.clients.filter(client=>client._id===clientID);
        return user[0];
    } catch (error) {
        console.error("Error on getting current user: ",error);
        return null;
    }
}


// ===========================
// Functions to add a new data
// ===========================

// Add an object to array
export const addData = async (_websiteID, _parameter, _data)=>{
    try{
        await updateDoc(doc(db,"websites",_websiteID),{
            [_parameter]: arrayUnion(_data)
        })
        await new Promise(resolve => setTimeout(resolve, 1000));
        return true;
    } catch(err){
        console.error("Error adding data: ",err);
        return false;
    }
}


// ===================================
// Functions to update an existed data
// ===================================

// Update an object by it's parameter with a new data
export const updateData = async(_websiteID, _parameter, _data, toWait=true)=>{
    if(!_websiteID|| !_parameter || !_data || !db) return false;
    try{
        await updateDoc(doc(db,"websites",_websiteID),{
            [_parameter]: _data
        })
        if(toWait) await new Promise(resolve => setTimeout(resolve, 800));
        return true;
    } catch(err){
        console.error("Error updating data: ",err);
        return false;
    }
}
// Update an object inside an array that has itemID with a new itemUpdated data
// And update the whole array according to parameter path at website
export const updateDataArray = async(_websiteID, _array, _itemID, _itemUpdated, _parameter)=>{
    try {
        const updatedArray = _array.map((obj)=>{
            if(obj?._id === _itemID){
                return {
                    ..._itemUpdated,
                    updatedAt: new Date(),
                };
            }
            return obj;
        })
        await updateData(_websiteID, _parameter, updatedArray);
        return true;
    } catch (error) {
        console.error("Error on updating data at array on firebase: ",error);
        return false;
    }
}

// Update an object inside an array that has itemID => but only it's complexParameter with a
// New data given => then update the whole array according to parameter path at website
// Example for usage:
// (website.id, website.settings.branches, branch._id, "week", branchActivity, "settings.branches")
// Updates the week parameter of branch._id with the new branchActivity data then updates
// The whole array at firestore to save changes
export const updateDataComplex = async(_websiteID, _array, _itemID, _complexParameter, _data, _parameter)=>{
     try{
        const updatedArray = _array.map((obj)=>{
            if(obj?._id === _itemID){
                return {
                    ...obj,
                    updatedAt: new Date(),
                    [_complexParameter]: _data
                };
            }
            return obj;
        })
        await updateData(_websiteID, _parameter, updatedArray);
        return true;
    } catch(err){
        console.error("Error updating complex data at firebase: ", err.message);
        return false;
    }
}

// Upload a new file image to firebase storage
// Differ storage path by websiteID and directory requested
// Update a refference path on the collection document at path given
// If isArray => update arrayField by it's arrayIndex
// If needed to update document => update the collection doc refference to storage path
export const uploadImage = async (websiteID, directory, path, file, isArray, arrayIndex, arrayField, toUpdateDoc) => {
    if (!file) return alert("No file selected");

    try {
        const websiteRef = doc(db, "websites", websiteID);
        const snap = await getDoc(websiteRef);
        if (!snap.exists()) throw new Error("Website not found");

        const data = snap.data();

        // Build new storage path
        const newImgPath = `${websiteID}/${directory}/${file.name}`;
        const storageRef = ref(storage, newImgPath);

        let oldPath = null;

        // Not an array
        if (!isArray) {
            oldPath = getNestedValue(data, path);

            // Check if image already exists at same path to prevent unnecessary changes
            if (oldPath === newImgPath) {
                console.warn("Same image selected, skipping update.");
                return {path: oldPath, toChange: false};
            }

            // Upload file only if different images
            await uploadBytes(storageRef, file);

            // Attempt to delete old image on path to prevent multiplications
            if (typeof oldPath === "string" && oldPath.length > 0) {
                await deleteObject(ref(storage, oldPath)).catch(() =>
                    console.warn("Old image not found to delete")
                );
            }
            // Upload document if needed
            if(toUpdateDoc){
                await updateDoc(websiteRef, { [path]: newImgPath });
            }
        } else { // => Is an array:

            // On the website document data => catch the path to array
            let arr = getNestedValue(data, path) || [];
            
            // If misstakenly got an isArray and not an array => return error
            if (!Array.isArray(arr)) throw new Error(`${path} is not an array`);
            
            // Check if umage already exists and updated on document
            const existsAlready = arr.some(item =>
                arrayField ? item?.[arrayField] === newImgPath : item === newImgPath
            );

            // If exists => return old path and do not change
            if (existsAlready) {
                return {path: oldPath, toChange: false};
            }

            // Prevent an exception of array index by array actual length
            if (arrayIndex === null || arrayIndex < 0) {
                arrayIndex = arr.length;
            }

            // Make sure index is still on array range
            // Set old path to hold arrayField if exists,
            // If array field not exists check if the array field exists on array index
            // Else set old path to be the array item at index
            if (arrayIndex < arr.length) {
                oldPath = arrayField
                    ? arr[arrayIndex]?.[arrayField]
                    : arr[arrayIndex];
            }
            // If image already exists => prevent document changes
            if (oldPath === newImgPath) {
                console.warn("Same image selected in array, skipping update.");
                return {path: oldPath, toChange: false};
            }

            // Upload file only if different images
            await uploadBytes(storageRef, file);

            // Delete old image after upload new image
            if (typeof oldPath === "string" && oldPath.length > 0) {
                await deleteObject(ref(storage, oldPath)).catch(() =>
                    console.warn("Old image not found to delete")
                );
            }
            // If need to upload document => find the array specific path and update
            if(toUpdateDoc){
                if (arrayIndex >= arr.length) {
                    arr.push(arrayField ? { [arrayField]: newImgPath } : newImgPath);
                } else {
                    if (arrayField) {
                        arr[arrayIndex] = {
                            ...(arr[arrayIndex] || {}),
                            [arrayField]: newImgPath,
                        };
                    } else {
                        arr[arrayIndex] = newImgPath;
                    }
                }
    
                await updateDoc(websiteRef, { [path]: arr });
            }
        }

        return {path: newImgPath, toChange: true};
    } catch (err) {
        console.error("Error uploading image at firebase: ", err);
        return null;
    }
};


// ===================================
// Functions to remove an existed data
// ===================================

// Remove an object from an array
export const removeData = async(_websiteID, _parameter, _data)=>{
    try{
        await updateDoc(doc(db,"websites",_websiteID),{
            [_parameter]: arrayRemove(_data)
        })
        await new Promise(resolve => setTimeout(resolve, 300));
        return true;
    } catch(err){
        console.error("Error removing data: ",err);
        return false;
    }
}


// =====================================
// Website updates(subscription process)
// =====================================

// Adding a new website document to firestore collection
export const addWebsite = async(_website)=>{
    try{
        const websitesRef = collection(db, "websites");
        const docRef = await addDoc(websitesRef, _website);
        return docRef.id ? true : false;
    } catch(err){
        console.error("Error adding website: ", err);
        throw new Error("Failed to add website to Firestore: " + err.message);
    }
}
// Remove a website document from firestore collection
export const removeWebsite= async(_id)=>{
    try{
        const websiteDocRef = doc(db, "websites", _id);
        await deleteDoc(websiteDocRef);
    } catch(err){
        console.error("Error deleting website: ", err);
        throw new Error("Failed to delete website from Firestore: " + err.message);
    }
}



// ==============================================================================================
// |--------------------------------------- Dashboard ------------------------------------------|
// ==============================================================================================

// ========================
// Functions to update data
// ========================
// Updating business info at firestore
export const updateBusinessInfo = async(_websiteID, newData)=>{
    try{
        
        const res1 = await updateData(_websiteID, "settings.website_name", newData.name)
        const res2 = await updateData(_websiteID, "settings.email", newData.email)
        const res3 = await updateData(_websiteID, "settings.phone", newData.phone)
        const res4 = await updateData(_websiteID, "settings.address", newData.address)
        if(res1&&res2&&res3&&res4){
            return true;
        }
        return false;
    } catch(err){
        console.error("Error on updating business info: ",err);
        return false;
    }
}
// Updating personal info at firestore
export const updatePersonalInfo = async(_website, newData, currentPass, setCurrentManager, setToastMessage, messagesOptions)=>{

    try{
        const res1 = await updateData(_website.id, "owner.name", newData.name)
        const res2 = await updateData(_website.id, "owner.email", newData.email)
        const res3 = await updateData(_website.id, "owner.phone", newData.phone)

        const user = auth.currentUser;
        if (!user) throw new Error("No authenticated user");
        await user.reload();
        const credential = EmailAuthProvider.credential(
            user.email,
            currentPass
        );
        await reauthenticateWithCredential(user, credential);
        await verifyBeforeUpdateEmail(user, newData.email.trim());
        setToastMessage(messagesOptions.emailUpdated);
        if(res1&&res2&&res3){
            const owner = await getData(_website.id, "owner", _website.owner._id);
            if(owner!==null&& owner!==undefined){
                setCurrentManager(owner);
                return true;
            }
        }
        return false;
    } catch(err){
        console.error("Error on update personal info: ",err);
        return false;
    }
}



// =====================
// Functions to add data
// =====================
// Add a new product to the category given
export const addProductToCategory = async(_websiteID, _categoryID, _newProduct)=>{
    try{
        const ref = doc(db, "websites", _websiteID);
        const snap = await getDoc(ref);

        if (!snap.exists()) return console.error("Document not found");
        const data = snap.data();
        const categories = data.settings.categories || [];

        // Find the category you want to update
        const updatedCategories = categories.map(cat => {
            if (cat._id === _categoryID) {
                // Add the new product to its products array
                return {
                    ...cat,
                    updatedAt: new Date(),
                    products: [...(cat.products || []), _newProduct]
                };
            }
            return cat;
        });
        
        // Update the document
        await updateData(_websiteID, "settings.categories", updatedCategories);
        return true;
    }
    catch(err){
        console.error("Error on adding product to category at firebase: ",err);
        return false;
    }
}


// ==============================================================================================
// |------------------------------------ Authentication ----------------------------------------|
// ==============================================================================================

// ================================
// Clients signup/signin at website
// ================================
// Add new client to website's clients
export const addNewClient = async(websiteID, newClient)=>{
    try{
        const res = await addData(websiteID, "settings.clients", newClient);
        return res;

    } catch(err){
        console.error("Error on adding new client: "+err)
    }
}
// Login client at website login
export const handleLoginClient = async(websiteID, userCredentials)=>{
    try{
        const websiteRef = doc(db, "websites", websiteID);
        const snap = await getDoc(websiteRef);
        const data = snap.data();
        const _user = data?.settings?.clients.filter((user)=>{
            return user.pass === userCredentials.pass && user.email === userCredentials.email;
        });
        await new Promise(resolve => setTimeout(resolve, 500));
        return _user[0];
    } catch(err){
        console.error("Error on trying login client: "+err)
    }
}

// ====================
// Subscription process
// ====================
// At subscription process - page one(owner creation form) => check if user already exists
export const handleCheckExistance = async(email, phone)=>{
    try {
        const websitesCollection = await getCollectionDocs("websites");
        var exists = {email:false, phone:false};
        websitesCollection.map((doc)=>{
            if(doc?.owner?.email === email){
                exists.email = true; 
            }
            if(doc?.owner?.phone === phone){
                exists.phone = true; 
            }
            return doc;
        });
        return exists;
    } catch (error) {
        console.error("Error on checking existance at firebase functions file: ",error);
    }
}

// Handle the user signing up at firebase authentication
export const handleSignUp = async(email, password, _website) => {
    if(!email || !password){
        alert("something went wrong with credentials:" + email + " | " + password);
        return false;
    }
    try{
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        const uid = user.uid;
        if(!uid){return false}
        _website.owner.uid=uid;
        const res = await addWebsite(_website);
        
        await sendEmailVerification(user);
        return {message:"success", data:res};
    } catch (error) {
        const errorCode = error.code;
        const errorMessage = error.message;

        console.error("Error signing up:", errorCode, errorMessage);

        // Provide user-friendly error messages
        switch (errorCode) {
        case 'auth/email-already-in-use':
            return {message:"emailTaken"};
        case 'auth/invalid-email':
            return {message:"emailNotValid"};
        case 'auth/weak-password':
            return {message:"passwordTooWeak"};
        default:
            alert(`שגיאת מערכת: ${errorMessage}`);
            return {message:"error"};
        }
    }
}

// Handle the user signing in from firebase authentication
export const handleSignIn= async(email, password, setCurrentManager, setCurrentManagerUID, setToastMessage, messagesOptions)=>{
    if(!email || !password){
        setToastMessage(messagesOptions.aware);
        return false;
    }
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential?.user;
        const uid = user?.uid;
        // if not admin then get website, otherwise - get all websites:
        if(email==="admin@gmail.com" && password==="Adm!n123"){
            const websites = await getCollectionDocs("websites");
            setCurrentManager({
                name:"Admin",
                email,
                uid,
                websites,
                clients: websites.map((site)=>{
                    return {...site.owner, websiteID: site.id}
                })
            });
            setCurrentManagerUID(uid);
            return { admin:true };
        }
        else{
            const res = await getWebsite("owner.uid",uid);
            setCurrentManager(res.owner);
            setCurrentManagerUID(res.owner.uid);
            return {user: true, data: res};
        }
    } catch (error) {
        const errorCode = error.code;
        const errorMessage = error.message;

        console.error("Error signing in:", errorCode, errorMessage);
        var err = "";
        switch (errorCode) {
            case 'auth/invalid-email':
                err = "אימייל לא תקין";
                break;
            case 'auth/user-not-found':
                err = "לא נמצא משתמש עם הפרטים שהוזנו";
                break;
            case 'auth/invalid-credential':
                err = "לא נמצא משתמש עם הפרטים שהוזנו";
                break;
            case 'auth/wrong-password':
                err = "הסיסמא לא תואמת";
                break;
            case 'auth/too-many-requests':
                err = "יותר מידי ניסיונות, אנא נסה שנית במועד מאוחר יותר.";
                break;
            default:
                err = "הפעולה נכשלה, נסה לרענן את הדף";
        }
        return { err };
    }
}



// ==============================================================================================
// |------------------------------------ Helper methods ----------------------------------------|
// ==============================================================================================
// Get a string "website.settings.clients" and transfer it into actual object path referrence
// Like website.settings.clients => which is an array of clients for example
export function getNestedValue(obj, path) {
    return path?.split(".")?.reduce((acc, key) => {
        if (acc && typeof acc === "object" && key in acc) return acc[key];
        return undefined;
    }, obj);
}

// ==========================================================================
// when user landing on a website - check if he already visited by it's IP
// If the IP is the last IP been on the site - the function never been called
// If a new client - add him to the website logs as new log
// If already been on that site - update his time of visits
// ==========================================================================
export const addWebsiteLog = async(website, _ip)=>{
    try {
        var isExist = false;
        const logsArr = website?.logs || [];
        const updatedLogs = await Promise.resolve(logsArr.map((log)=>{
            if(log.ip ===_ip){
                isExist = true;
                return {
                    ...log,
                    timesVisited:log.timesVisited+1
                }
            }
            return log
        }))
        var res = false;
        if(isExist){
            // update the whole log array
            res = await updateData(website.id, "logs", updatedLogs);
        }
        else if(!isExist || logsArr.length===0){
            const newLog =  {
                ip:_ip,
                timesVisited:1,
                createdAt: new Date()
            }
            res = await addData(website.id, "logs", newLog);
        }
        return res;
    } catch (error) {
        console.error("Error on adding log: ",error);
    }
}

export const getPage = async(websiteId, pageId) => {
    const snap = await getDoc(doc(db, "websites", websiteId));
    if (!snap.exists()) return null;
    // console.log("exists: ",snap.data()?.settings?.pages?.[pageId]);
    return snap.data()?.settings?.pages?.[pageId] || null;
}